import {
	DISABLED_INPUT_COLOR,
	MAIN_COLOR,
	SHADOW_COLOR,
	STAFF_COLOR,
	TEXT_COLOR,
} from 'shared/consts';
import { styled, css } from 'styled-components';

export interface InputProps {
	$height?: string;
	$width?: string;
	$padding?: string;
	$fontSize?: string;
	$cursorPointer?: boolean;
	$borderRadius?: string;
	$textIndent?: string;
  $hide?: boolean;
  $pen?: boolean;
}

export const sharedStyles = css<InputProps>`
	border-width: 1px;
	border-radius: ${props => props.$borderRadius || '24px'};
	border: 1px solid white;
	font-size: ${props => props.$fontSize || 'inherit'};
	height: ${props => props.$height || '40px'};
	width: ${props => props.$width || '100%'};
	padding: ${props => props.$padding || 'initial'};
	background: white;
	color: ${TEXT_COLOR};
	text-indent: ${props => props.$textIndent || 'initial'};
	font-family: Open Sans;

	outline: none;

	${props =>
		props.$cursorPointer &&
		css`
			cursor: pointer;
		`}

	&:focus {
		border-color: ${MAIN_COLOR};
		box-shadow: 0 0 5px ${SHADOW_COLOR};
	}

	&::placeholder {
		color: ${STAFF_COLOR}
	}
`;

export const InputText = styled.input<InputProps>`
	${sharedStyles}

	&:disabled {
		background-color: ${DISABLED_INPUT_COLOR};
		color: white;
		border-color: ${DISABLED_INPUT_COLOR};
	}
`;
